import { Controller } from "@hotwired/stimulus";

// Affiche un aperçu miniature quand l'utilisateur sélectionne une image
// Réutilisable sur tout formulaire avec un champ fichier image
export default class extends Controller {
  static targets = ["input", "preview"];

  static values = {
    validTypes: {
      type: Array,
      default: ["image/png", "image/jpeg", "image/webp", "image/gif", "image/svg+xml"],
    },
    maxSize: { type: Number, default: 5242880 },
    // Textes UI i18n (audit 2026-08-04, A6-F6) : defaults FR, alimentés par
    // data-image-preview-*-value avec t() — clés stimulus.image_preview.*
    // maxSizeMessage est le message COMPLET (interpolé côté serveur) : une vue
    // qui change maxSize doit fournir le message assorti (review PR #56 — le
    // replace("%{size}") était un no-op qui masquait la source de vérité).
    invalidTypeMessage: { type: String, default: "Format d'image non supporté" },
    maxSizeMessage: { type: String, default: "La taille de l'image ne doit pas dépasser 5 MB" },
  };

  preview(event) {
    const file = event.target.files[0];

    if (!file) {
      this.hidePreview();
      return;
    }

    if (!this.validateFile(file)) {
      this.inputTarget.value = "";
      this.hidePreview();
      return;
    }

    this.showPreview(file);
  }

  validateFile(file) {
    if (!this.validTypesValue.includes(file.type)) {
      alert(this.invalidTypeMessageValue);
      return false;
    }

    if (file.size > this.maxSizeValue) {
      alert(this.maxSizeMessageValue);
      return false;
    }

    return true;
  }

  showPreview(file) {
    if (!this.hasPreviewTarget) return;

    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }

    this.objectUrl = URL.createObjectURL(file);
    this.clearPreview();

    const img = document.createElement("img");
    img.src = this.objectUrl;
    img.className = "h-20 w-auto rounded";
    img.alt = file.name;

    this.previewTarget.appendChild(img);
    this.previewTarget.classList.remove("hidden");
  }

  hidePreview() {
    if (!this.hasPreviewTarget) return;

    this.clearPreview();
    this.previewTarget.classList.add("hidden");
  }

  clearPreview() {
    if (!this.hasPreviewTarget) return;

    while (this.previewTarget.firstChild) {
      this.previewTarget.removeChild(this.previewTarget.firstChild);
    }
  }

  disconnect() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
